// Ported 1:1 from the ToyamaCRM UI Redesign Brief mock's sparkPts/sparkArea
// (ToyamaCRM.dc.html) — normalizes a series of values into an SVG polyline
// `points` string and a matching filled-area `path`, scaled to a viewBox of
// `w`x`h`. This normalization logic IS the design spec; no chart library.

export function sparkPoints(vals: number[], w: number, h: number): string {
  const max = Math.max(...vals);
  const min = Math.min(...vals);
  const rng = max - min || 1;
  return vals
    .map((v, i) => {
      const x = ((i * w) / (vals.length - 1)).toFixed(1);
      const y = (h - 2 - ((v - min) / rng) * (h - 5)).toFixed(1);
      return `${x},${y}`;
    })
    .join(' ');
}

export function sparkArea(vals: number[], w: number, h: number): string {
  return 'M' + sparkPoints(vals, w, h).split(' ').join(' L') + ` L${w},${h} L0,${h} Z`;
}

// A trend array as sent by GET /api/dashboard is 8 weekly values where a week
// with no data at all is `null` (not 0). Sparklines are drawn over only the
// weeks that have a value — nulls are dropped rather than interpolated — and
// omitted entirely below 2 points (nothing meaningful to draw a line through).
export function trendToSpark(
  trend: (number | null)[],
  w: number,
  h: number
): { points: string; area: string } | null {
  const vals = trend.filter((v): v is number => v !== null && v !== undefined);
  if (vals.length < 2) return null;
  return { points: sparkPoints(vals, w, h), area: sparkArea(vals, w, h) };
}
